import { useTheme, useMediaQuery } from '@mui/material';
import FascicoloDetailPageDesktop from './FascicoloDetailPageDesktop';
import FascicoloDetailPageMobile from './FascicoloDetailPageMobile';

export default function DocumentiListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <FascicoloDetailPageMobile />
    : <FascicoloDetailPageDesktop />;
}